<div class="flex" flex-align-items-center>
	<oct-avatar-icon *ngIf="!hide" [fullName]="option.FULL_NAME" [size]="27"></oct-avatar-icon>
	<div class="option-text">{{option.FULL_NAME}}</div>
</div>
